<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">标段名称：</span>
        <el-input v-model="search.segmentName" :size="size" clearable placeholder="请输入标段名称"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">项目名称：</span>
        <el-select v-model="search.proId" placeholder="请选择项目名称" clearable>
            <el-option
            v-for="item in optionsProject"
            :key="item.proId"
            :label="item.proName"
            :value="item.proId">
            </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="proName" label="项目名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="segmentName" label="标段名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="shieldEnp" label="盾构单位" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="station" label="站点" align="center"></el-table-column>
        <el-table-column prop="realName" label="负责人" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增标段' : '修改标段'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="项目名称：" prop="proId">
          <el-select v-model="ruleForm.proId" placeholder="请选择项目名称" @change="changeNeed">
                <el-option
                v-for="item in optionsProject"
                :key="item.proId"
                :label="item.proName"
                :value="item.proId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="标段名称：" prop="segmentName">
          <el-input v-model="ruleForm.segmentName" :size="size" clearable placeholder="请输入标段名称"></el-input>
        </el-form-item>
        <el-form-item label="需求负责人：" prop="segmentAdmin">
          <el-select v-model="ruleForm.segmentAdmin" placeholder="请选择需求负责人">
                <el-option
                    v-for="item in optionsUser"
                    :key="item.userId"
                    :label="item.realName"
                    :value="item.userId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="盾构单位：" prop="shieldEnp">
          <el-input v-model="ruleForm.shieldEnp" :size="size" clearable placeholder="请输入盾构单位"></el-input>
        </el-form-item>
        <el-form-item label="站点：" prop="station">
          <el-input v-model="ruleForm.station" :size="size" clearable placeholder="请输入站点"></el-input>
        </el-form-item>
        <div class="section_needs">标段需求</div>
        <div class="section_needs_content">
            <div v-for="item in needBlocks" :key="item.dictId" class="needs_items">
                <div class="needs_text">{{item.dictName}}</div>
                <el-input placeholder="请输入数量" type="number"  v-model="item.needNum" class="needs_num">
                    <template slot="append">块</template>
                </el-input>
            </div>  
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //标段信息列表
        optionsUser:[],//需求负责人
        optionsProject:[],//项目名称
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {}, // 按钮表单
        rules: {
          segmentName: [{
            required: true,
            message: '请输入标段名称',
            trigger: 'blur'
          }],
          shieldEnp: [{
            required: true,
            message: '请输入盾构单位',
            trigger: 'blur'
          }],
          station: [{
            required: true,
            message: '请输入站点',
            trigger: 'blur'
          }],
          proId: [{
            required: true,
            message: '请选择项目名称',
            trigger: 'change'
          }],
          segmentAdmin: [{
            required: true,
            message: '请选择需求负责人',
            trigger: 'change'
          }],
        },
        needBlocks:[],//标段需求
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
      that.getAllProjects()
      that.getAllPersons()
    },
    methods: {
    //通过不同的项目展示不同的标段需求
    changeNeed(val){
        let obj = {
            proId:val
        }
        this.needBlocks = []
        this.$api.Reinforce.searchProjectBears(obj).then(res=>{
            if(res.statusMsg ==='ok'){
              if(this.ruleForm.proId ===''){
                this.needBlocks = []
              }else{
                res.data.blokDtos.forEach(item=>{
                    this.needBlocks.push({
                        dictName:item.blockName,
                        needType:item.blockNum,
                        needNum:0,
                        segmentId:''
                    })
                })
              }
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
    },
     //获得所有人员
     getAllPersons(){
        this.$api.Engineer.getPersonsList({}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsUser = res.data
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
     },
     //获得所有项目名称
     getAllProjects(){
        let obj = {
            pageNum: 1,
            pageSize: 100000000
        }
        this.$api.Engineer.searchProjects(obj).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsProject = res.data.list
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
     },
     //获取块号
      getAllBlocks(){
        let params = {
            pageNum: 1,
            pageSize: 100000000
        }
        this.$api.Dictionary.searchDictionary(params).then(res=>{
            if(res.statusMsg === 'ok'){
              if(this.ruleForm.proId===undefined){
                this.needBlocks = []
              }else{
                res.data.list.filter(item =>item.dictType === '5').forEach(iten=>{
                    this.needBlocks.push({
                        dictName:iten.dictName,
                        needType:iten.dictId,
                        needNum:0,
                        segmentId:''
                    })
                })
              }
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.$api.Engineer.searchSegment(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
        this.getAllBlocks()
        if(this.ruleForm.proId===undefined){
          this.needBlocks = []
        }else{
          this.needBlocks.forEach(item=>{
              item.needNum = 0
          })
        }
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.$api.Engineer.detailsSegment({segmentId: row.segmentId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
                this.needBlocks = res.data.segmentNeeds
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Engineer.deleteSegment({segmentId: row.segmentId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.segmentList = this.needBlocks
            this.$api.Engineer.insertSegment(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.segmentList = this.needBlocks
            this.$api.Engineer.updateSegment(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
.section_needs{
    position: relative;
    color:#18F5F7;
    padding: 20px 20px 10px 15px;
    border-bottom: 1px solid #1949A3;
    &::before{
        position: absolute;
        content: "";
        width: 2px;
        height: 20px;
        background-color: #18F5F7;
        top: 20px;
        left: 5px;
    }
}
.section_needs_content{
    height: 180px;
    overflow: auto;
    display: flex;
    // flex-direction: column;
    // justify-content: space-between;
    flex-wrap: wrap;
    // &:after{
    //     content: "";
    //     flex: 0 0 412px;
    // }
    .needs_items{
        max-width: 190px;
        min-width: 142px;
        padding: 15px;
        display: flex;
        .needs_text{
            // width: 50px;
            flex: none;
            align-self: center;
            text-align: center;
            padding-right: 15px;
            color: #E1E3E9;
        }
        .needs_num{
            align-self: center;
        }
    }
}

</style>